<template>
	<div class="max-w-screen-xl mx-auto root">
		<Head>
			<title>{{ fullTitle }}</title>
		</Head>
		<Analytics :title="fullTitle" />
		<clear-session-storage />
		<!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
		<div
			class="fixed inset-0 flex z-40 md:hidden"
			role="dialog"
			aria-modal="true"
			v-if="showSidebar"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-600 bg-opacity-75"
					aria-hidden="true"
					v-if="showSidebarInner"
					v-on:click="closeSidebar()"
				></div>
			</transition>

			<transition name="slidein">
				<div
					v-if="showSidebarInner"
					ref="sidebarSlidein"
					class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-green"
				>
					<div class="absolute top-0 right-0 -mr-12 pt-2">
						<button
							v-on:click="closeSidebar()"
							type="button"
							class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
						>
							<span class="sr-only">Close sidebar</span>
							<ui-icon class="h-6 w-6 text-white" name="x" stroke-width="2" />
						</button>
					</div>

					<!-- <div class="flex-shrink-0 flex items-center px-4">
                        <a :href="homeLink" class="md:hidden">
                            <ui-icon class="ml-2 h-10 w-10" name="logo" fill="#ffffff" />
                        </a>

                        <img class="h-8 w-auto" :src="logoUrl" alt="Workflow" />
                    </div> -->
					<layout-navbar-side-items />
				</div>
			</transition>
			<div class="flex-shrink-0 w-14" aria-hidden="true">
				<!-- Dummy element to force sidebar to shrink to fit close icon -->
			</div>
		</div>

		<!-- Static sidebar for desktop -->
		<div class="hidden md:flex md:w-56 md:flex-col md:fixed md:inset-y-0">
			<!-- Sidebar component, swap this element with another sidebar if you like -->
			<div class="flex flex-col flex-grow pt-4 mt-4 overflow-y-auto">
				<div class="flex items-center flex-shrink-0 px-4">
					<!-- <img class="h-40 w-auto mx-auto" :src="logoUrl"/> -->
					<ui-icon name="logo" class="h-40 w-auto mx-auto" />
				</div>
				<layout-navbar-side-items />
			</div>
		</div>

		<div
			class="md:pl-56 flex flex-col flex-1 min-h-screen-fix"
			:class="[maxScreenHeight ? 'md:max-h-screen-fix' : '']"
		>
			<div class="top-0 z-10 flex-shrink-0 flex h-12 bg-white items-center">
				<a :href="homeLink" class="md:hidden"
					><ui-icon class="ml-2 h-10 w-10" name="logo"
				/></a>

				<layout-navbar-top />

				<button
					v-on:click="toggleSidebar()"
					type="button"
					class="rounded-lg p-2 hover:bg-gray-100 mr-2 md:hidden"
				>
					<span class="sr-only">Open sidebar</span>
					<ui-icon class="h-6 w-6" name="menu" stroke-width="2" />
				</button>
			</div>

			<main
				class="max-h-full flex-grow flex flex-col"
				:class="[maxScreenHeight ? 'md:overflow-hidden' : '']"
			>
				<transition name="zoomin">
					<div
						class="flex-grow flex flex-col"
						v-if="showContent"
						:class="[maxScreenHeight ? 'md:overflow-hidden' : '']"
					>
						<slot />
					</div>
				</transition>
				<layout-modal-container />
			</main>
		</div>
	</div>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue";
export default {
	props: {
		maxScreenHeight: false,
		title: {
			type: String,
			required: false,
		},
	},
	components: {
		Head,
	},
	data() {
		return {
			showSidebar: false,
			showSidebarInner: false,
			showContent: false,
			//iframeModalUrl: null,
			//showPermissionDeniedModal: false,
		};
	},
	mounted() {
		this.showContent = true; // toggle the transition
	},
	methods: {
		toggleSidebar() {
			console.log("TOGGLE SIDEBAR");
			this.showSidebar = true;
			this.$nextTick(() => (this.showSidebarInner = true));
		},
		closeSidebar() {
			let that = this;
			setTimeout(function () {
				that.showSidebar = false;
			}, 300);
			this.showSidebarInner = false;
		},
	},
	computed: {
		logoUrl: () => window.baseUrl + "/images/cropspot-logo.svg",
		homeLink() {
			return window.baseUrl;
		},
		fullTitle() {
			return (this.title ? __(this.title) + " | " : "") + "cropspot";
		},
	},
};
</script>

<style>
/* New mobile safari min-/max-screen-height fix
    /* https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/*/
/* https://stackoverflow.com/questions/69769235/chrome-ipad-has-wrong-viewport-height */
/* ... setting body height to '-webkit-fill-available' causes modals to be hidden */

/* for mobile safari
    .min-h-screen {
        min-height: 100vh;
        min-height: -webkit-fill-available;
    }
    .max-h-screen {
        max-height: 100vh;
        max-height: -webkit-fill-available;
    }
    @media (min-width: 768px) {
        .md\:max-h-screen {
            max-height: 100vh;
            max-height: -webkit-fill-available;
        }
    }*/
</style>
